<template>
  <div v-if="supported" class="audience-filters">
    <label>{{ $t("common.country") }}
      <select v-model="audience.country_code" @change="changed">
        <option value="">{{ $t("common.allCountries") }}</option>
        <option v-for="country in countries" :key="country.code" :value="country.code">{{ countryName(country.code) }}</option>
      </select>
    </label>
    <label>{{ $t("common.dataLanguage") }}
      <select v-model="audience.language_code" @change="changed">
        <option value="">{{ $t("common.allLanguages") }}</option>
        <option v-for="language in languages" :key="language.code" :value="language.code">{{ language.native_name }}</option>
      </select>
    </label>
    <span v-if="failed" role="alert">{{ $t("common.catalogFailed") }} <button type="button" @click="load">{{ $t("common.retry") }}</button></span>
  </div>
</template>
<script setup>
/* global defineEmits */
import { computed, onMounted, ref } from "vue";
import { useRoute } from "vue-router";
import { useI18n } from "vue-i18n";
import axios from "axios";
import { audience, audienceRoutes, persistAudience } from "@/i18n/audience";
const emit = defineEmits(["changed"]);
const route = useRoute();
const { locale } = useI18n();
const supported = computed(() => audienceRoutes.includes(route.path));
const languages = ref([]);
const countries = ref([]);
const failed = ref(false);
function countryName(code) { return new Intl.DisplayNames([locale.value], { type: "region" }).of(code); }
function changed() { persistAudience(); emit("changed"); }
async function load() {
  failed.value = false;
  try {
    const { data } = await axios.get(`${process.env.VUE_APP_API_URL}/api/v1/internationalization`);
    languages.value = data.languages;
    countries.value = data.filter_countries || data.countries;
  } catch { failed.value = true; }
}
onMounted(load);
</script>
<style scoped>
.audience-filters { display: flex; flex-wrap: wrap; align-items: center; gap: 1rem; margin: 1rem; }
label { display: flex; align-items: center; gap: .5rem; }
select { padding: .5rem; color: inherit; background: transparent; border: 1px solid #999; border-radius: 5px; }
</style>
